export const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    textAlign: "center",
    bgcolor: "#f5f5f5",
    padding: 2,
  },
  icon: {
    fontSize: 80,
    color: "#9e9e9e",
    mb: 2,
  },
  description: {
    mb: 3,
  },
  button: {
    textTransform: "none",
  },
};
